import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import Home  from "./Components/Home_Page";
import About from "./Components/About_Section";
import CollegeActivitiesMain from "./Components/Activities_Section";
import Chapters from "./Components/Chapters.jsx";
import Camps from "./Components/Camps.jsx";
import AlumnusNetwork from "./Components/Alumnus_Network.jsx";
import Dashboard from "./Components/Dashboard.jsx";
import RegistrationApp from "./Components/Registration_App";
import ProfileEdit from "./Components/Profile/Profile_Edit";
import ProfileCard from "./Components/Profile/Profile_Card";
import LoginApp from "./Components/Login_App.jsx";
import ValuesApp from "./Components/Values_App.jsx";
import CampusAmbassador from "./Components/Campus_Ambassador.jsx";
import EthiccraftCollege from './Components/Colleges_Ethiccraft/EthiccraftCollege.jsx';
import ObjectivesApp from "./Components/Objectives/Objectives_App.jsx";
import "aos/dist/aos.css";
import 'font-awesome/css/font-awesome.min.css';
import './App.css'

function App() {
  const Navigate = useNavigate();
  
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  
  return (
    <div>
      <Routes>        
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/activities" element={<CollegeActivitiesMain  />} />
        <Route path="/chapters" element={<Chapters/>} /> 
        <Route path="/:collegeCode" element={<EthiccraftCollege />} />
        <Route path="/camps" element={<Camps />} />
        <Route path="/valumni" element={<AlumnusNetwork/>} />
        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/profileEdit" element={<ProfileEdit />} />
        <Route path="/register" element={<RegistrationApp />} />
        <Route path="/profile" element={<ProfileCard />} />
        <Route path="/values/*" element={<ValuesApp />} />
        <Route path="/objectives" element={<ObjectivesApp />} />
        <Route path="/login" element={<LoginApp/>} />
        <Route path="/campus-ambassador" element={<CampusAmbassador />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;